export default __webpack_public_path__ + "static/media/slide11.c6024b1f.png";